<div class="wrapper">
    @let _policies = policies();
    @if (_policies != undefined) {
        <div class="grid">
            <div class="header">
                <span>Policies</span>
                <button kendoButton (click)="this.addPolicyDialogVisible=true" themeColor="primary">Add</button>
            </div>
            <kendo-grid [data]="_policies" class="kendo-grid-custom" [sortable]="true" [selectable]="true" [size]="'small'">
                <kendo-grid-column field="service" title="service"></kendo-grid-column>
                <kendo-grid-column field="system" title="system(s)"></kendo-grid-column>
                <kendo-grid-column field="action" title="permissions">
                </kendo-grid-column>
                <kendo-grid-column field="sub" title="" [width]="60" [filterable]="false">
                    <ng-template kendoGridCellTemplate="" let-dataItem>
                        <button kendoButton (click)="this.onPolicyDelete(dataItem)" [svgIcon]="trashIcon"></button>
                    </ng-template>
                </kendo-grid-column>
                
            </kendo-grid>
            @if (this.addPolicyDialogVisible) {
                <kendo-dialog title="Add Policy" (close)="this.addPolicyDialogVisible = false">
                    <div>
                        <kendo-label>Service<kendo-combobox [(ngModel)]="newPolicy.service" [data]="this.services"></kendo-combobox></kendo-label>
                        <kendo-label>System(s)<kendo-textbox [(ngModel)]="newPolicy.system"></kendo-textbox></kendo-label>
                        <kendo-label>Action<kendo-combobox [(ngModel)]="newPolicy.action" [data]="this.actions"></kendo-combobox></kendo-label>
                    </div>
                    <kendo-dialog-actions>
                        <button kendoButton (click)="this.addPolicyDialogVisible = false">Cancel</button>
                        <button kendoButton (click)="this.onPolicyAdd()" themeColor="primary">
                            Add
                        </button>
                    </kendo-dialog-actions>
                </kendo-dialog>

            }
        </div>
    }
    @let _sadmin = this.serviceAdmin();
    @if (_sadmin != undefined) {
        <div class="grid">
            <div class="header">
                <div>Service Admin for</div>
                <button kendoButton (click)="this.addServiceAdminDialogVisible=true" themeColor="primary">Add ServiceAdmin</button>
            </div>
            <kendo-grid [data]="_sadmin" class="kendo-grid-custom" [sortable]="true" [selectable]="true" [size]="'small'">
                <kendo-grid-column field="service" title="service"></kendo-grid-column>
                <kendo-grid-column field="service" title="" [width]="60" [filterable]="false">
                    <ng-template kendoGridCellTemplate="" let-dataItem>
                        <button kendoButton (click)="this.onRemoveServiceAdmin(dataItem.service)" [svgIcon]="trashIcon"></button>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
            @if (this.addServiceAdminDialogVisible) {
                <kendo-dialog title="Add ServiceAdmin" (close)="this.addServiceAdminDialogVisible = false">
                    <div>
                        <kendo-label>Service<kendo-combobox [(ngModel)]="newPolicy.service" [data]="this.services"></kendo-combobox></kendo-label>
                    </div>
                    <kendo-dialog-actions>
                        <button kendoButton (click)="this.addServiceAdminDialogVisible = false">Cancel</button>
                        <button kendoButton (click)="this.onAddServiceAdmin()" themeColor="primary">
                            Add
                        </button>
                    </kendo-dialog-actions>
                </kendo-dialog>

            }
        </div>
    }
    @if (this.isAdmin()) {
        <div class="admin">ADMIN<button kendoButton themeColor="primary" (click)="this.onRemoveAdmin()">Remove Admin</button></div>
    } @else {
        <div><button kendoButton themeColor="primary" (click)="this.onMakeAdmin()">Make Admin</button></div>
    }
</div>
<!-- <pre>{{ rights.value() | json }}</pre> -->